import { CREATE_MITARBEITER } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useCreateMitarbeiter/graphql/mutations';
import {
  CreateMitarbeiterMutation,
  CreateMitarbeiterMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateMitarbeiter() {
  const [execute, result] = useMutation<
    CreateMitarbeiterMutation,
    CreateMitarbeiterMutationVariables
  >(CREATE_MITARBEITER);

  const createMitarbeiter = useCallback(
    (variables: CreateMitarbeiterMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createMitarbeiter, result] as const;
}
